module.exports = __webpack_public_path__ + "static/media/sopt25kz.19d74427.pdf";